<!-- Title -->
<div class="title-emphasis">
  <i class="title-ico anticon anticon-contacts"></i>
  <div>
    <!-- TODO Organization Change -->
    <h4 class="p-0 m-0">{{selectedClient?.personDO?.firstName || '' | translate }} {{selectedClient?.personDO?.lastName
      || '' | translate}}</h4>
    <span class="col-grey-dark">{{getDateString(selectedClient?.personDO?.dateOfBirth)}}</span>
  </div>
</div>

<!-- ddd -->
<pre *ngIf="false">{{configuredObject | json}}</pre>


<div *ngFor="let section of summarySectionsList; let pSectionIndex = index;let pSectionLast = last;">
  <!-- <div class="title-emphasis" *ngIf="section.titleWithIcon">
    <i nz-icon class="title-ico" nzType="section.icon"></i>
    <div>
      <h4 class="p-0 m-0">{{selectedClient?.personDO?.firstName || '' | translate }}
        {{selectedClient?.personDO?.lastName || '' | translate}}</h4>
      <span class="col-grey-dark">{{getDateString(selectedClient?.personDO?.dateOfBirth)}}</span>
    </div>
  </div> -->



  <div *ngIf="section.heading">
    <h3 class="heading heading-summary">{{section.heading}}</h3>
  </div>

  <ng-container [ngSwitch]="section.sectionType">
    <div *ngSwitchCase="'form'">

      <div class="summary-container summary-container-wide">
        <div *ngFor="let sData of section.sectionData">
          <span class="s-c-head">{{sData.label}}</span>
          <ng-container *ngIf="sData.key; else showNullData">
            <span *ngIf="sData.showTag">
              <ng-container *ngIf="sData.pipe; else showOnlyTag">
                <ng-container [ngSwitch]="sData.pipe">
                  <nz-tag *ngSwitchCase="'date'" [nzColor]="sData.tagColor">{{sData.value | date :
                    appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</nz-tag>
                  <nz-tag *ngSwitchCase="'technicalTranslate'" [nzColor]="sData.tagColor">{{sData.value |
                    technicalTranslate}}</nz-tag>
                </ng-container>
              </ng-container>
              <ng-template #showOnlyTag>
                <nz-tag [nzColor]="sData.tagColor">{{configuredObject[sData.key]}}</nz-tag>
              </ng-template>
            </span>

            <span *ngIf="sData.showBadge">
              <ng-container *ngIf="sData.pipe; else showOnlyBadge">
                <ng-container [ngSwitch]="sData.pipe">
                  <nz-badge *ngSwitchCase="'date'" [nzStatus]="sData.badgeStatus">{{configuredObject[sData.key] | date :
                    appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</nz-badge>
                  <nz-badge *ngSwitchCase="'technicalTranslate'"
                    [nzStatus]="sData.badgeStatus">{{configuredObject[sData.key] |
                    technicalTranslate}}</nz-badge>
                </ng-container>
              </ng-container>
              <ng-template #showOnlyBadge>
                <nz-badge [nzStatus]="sData.badgeStatus">{{configuredObject[sData.key]}}</nz-badge>
              </ng-template>
            </span>

            <span *ngIf="!sData.showTag && !sData.showBadge">
              <ng-container *ngIf="sData.pipe; else showOnlyData">
                <ng-container [ngSwitch]="sData.pipe">
                  <span *ngSwitchCase="'date'">{{configuredObject[sData.key] | date :
                    appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
                  <span *ngSwitchCase="'technicalTranslate'">{{configuredObject[sData.key] | technicalTranslate}}</span>
                </ng-container>
              </ng-container>
              <ng-template #showOnlyData>
                {{configuredObject[sData.key]}}
              </ng-template>
            </span>

            <small class="d-b" *ngIf="sData.additionalValue">( {{sData.additionalValue}} )</small>
          </ng-container>
          <ng-template #showNullData>
            <span>-</span>
          </ng-template>

        </div>

      </div>
    </div>

    <div *ngSwitchCase="'grid'">
      <nz-table *ngIf="section.sectionData" #dataListTable nzBordered nzTableLayout="fixed" nzSize="small"
        [nzData]="configuredObject[section.sectionData.listAttribute]" [nzShowPagination]="section.showPagination">
        <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
          <tr>
            <ng-container *ngFor="let item of section.sectionData.listHeader">
              <ng-container *ngIf="item.isVisible">
                <th *ngIf="item.sortFilter && item.searchFilter; else showHeaderWithSortOnly" nzCustomFilter nzShowSort
                  [nzColumnKey]="item.key" [nzWidth]="item.width">
                  {{item.header}}
                  <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu"
                    (nzVisibleChange)="filterMenuVisibilityChanged($event)">
                    <i nz-icon nzType="search" (click)="getConfigKey(item.key)"></i>
                  </nz-filter-trigger>
                </th>
                <ng-template #showHeaderWithSortOnly>
                  <th *ngIf="item.sortFilter; else showSearchFilterOnly" nzShowSort [nzColumnKey]="item.key"
                    [nzWidth]="item.width">
                    {{item.header}}
                  </th>
                </ng-template>
                <ng-template #showSearchFilterOnly>
                  <th *ngIf="item.searchFilter; else showOnlyTableHeader" nzCustomFilter [nzColumnKey]="item.key"
                    [nzWidth]="item.width">
                    {{item.header}}
                    <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu"
                      (nzVisibleChange)="filterMenuVisibilityChanged($event)">
                      <i nz-icon nzType="search" (click)="getConfigKey(item.key)"></i>
                    </nz-filter-trigger>
                  </th>
                </ng-template>
                <ng-template #showOnlyTableHeader>
                  <th [nzWidth]="item.width">{{item.header}}</th>
                </ng-template>


              </ng-container>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of dataListTable.data">
            <ng-container *ngFor="let config of section.sectionData.listHeader">
              <ng-container *ngIf="config.isVisible">
                <td *ngIf="config.applyColor; else showDataWithoutColor" nz-typography
                  [nzType]="data['color'] == 'error' ? 'danger' : data['color']">
                  <span *ngIf="config.pipe;else showColoredDataOnly">{{ (data[config.key] | technicalTranslate) ||
                    '-' }}</span>
                  <ng-template #showColoredDataOnly>{{ data[config.key] || '-' }}</ng-template>
                </td>
                <ng-template #showDataWithoutColor>
                  <td>
                    <span *ngIf="config.pipe;else showDataOnly">{{ (data[config.key] | technicalTranslate) ||
                      '-' }}</span>
                    <ng-template #showDataOnly>{{ data[config.key] || '-' }}</ng-template>
                  </td>
                </ng-template>
              </ng-container>
            </ng-container>
          </tr>
        </tbody>
      </nz-table>

      <!-- <app-generic-zero-ui [list]="configuredObject[section.sectionData.listAttribute]" icon="question-circle" title="No Data"
         message="No Data found in the List"></app-generic-zero-ui> -->
    </div>

    <div *ngSwitchCase="'custom-widget'">
      <ng-container *ngIf="section.sectionId =='address'">
        <div class="summary-container">
          <div *ngFor="let data of selectedClient?.clientAddressList || []">
            <span class="s-c-head">{{(data.typeCd | technicalTranslate) || '' | translate}}</span>
            {{data.addressLine1 || '' | translate }},{{data.addressLine2 || '' | translate}},{{data.addressLine3 || '' |
            translate}},
            {{(data.cityCd | technicalTranslate) || '' }},{{(data.stateCd | technicalTranslate : 'stateCd') || '' }},
            {{data.postCode}},{{(data?.countryCd | technicalTranslate : 'countryCd') || '' }}
          </div>
        </div>
      </ng-container>
    </div>

    <div *ngSwitchCase="'explanation-text'">
      <div [innerHtml]="section.sectionData.desc"></div>
      <span> </span>
    </div>

    <div *ngSwitchCase="'timeline'">
      <nz-timeline>
        <nz-timeline-item *ngFor="let sData of section.sectionData" [nzColor]="sData.timelineColor">
          <h4 class="f-w-600">{{sData.title}} <nz-tag [nzColor]="sData.statusColor">{{sData.status}}</nz-tag></h4>
          <p><i nz-icon [nzType]="sData.icon"></i>{{sData.date}} ({{sData.calcDays}})</p>
          <div *ngFor="let item of sData.addData">
            <div>{{item.key}} : {{item.value}}</div>
          </div>
        </nz-timeline-item>

      </nz-timeline>
    </div>
  </ng-container>

  <div *ngIf="!pSectionLast" class="m-t-40"></div>
</div>


<!-- End trial n error code -->